var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topic-bg",style:({ 'background-image': ("url(" + _vm.topicBg + ")") })},[(_vm.showMore)?_c('LoadMore',{attrs:{"color":_vm.color,"arrow":_vm.arrow,"arrowColor":_vm.arrowColor,"pagename":_vm.pagename}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3753ce62","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Topic.vue
// module id = null
// module chunks = 